import styled from '@emotion/styled'

export const Languages = styled.div`
  position: relative;
  top: 100%;
  z-index: 1;

  @media (max-width: 768px) {
    top: unset;
  }
`
